function isObject(obj: any) {
  if (typeof obj === 'object' && obj != null) {
    return true
  } else {
    return false
  }
}

function deepEqual(obj1: any, obj2: any): boolean {
  if (obj1 === obj2) {
    return true
  } else if (isObject(obj1) && isObject(obj2)) {
    if (Object.keys(obj1).length !== Object.keys(obj2).length) {
      return false
    }
    for (const prop in obj1) {
      if (!deepEqual(obj1[prop], obj2[prop])) {
        return false
      }
    }
    return true
  }
  return false
}

const DEFAULT_TTL = process.env.NODE_ENV === 'test' ? 1 : 24 * 60 * 60 * 1000

export class PromiseCache {
  private readonly cache = new Map()
  private readonly ttl: number
  constructor(ttl: number = DEFAULT_TTL) {
    this.ttl = ttl
  }

  get<T, U>(key: T, onMiss: (key: T) => Promise<U>): Promise<U> {
    for (const cachedKey of this.cache.keys()) {
      if (deepEqual(cachedKey, key)) {
        return this.cache.get(cachedKey)
      }
    }
    const promise = (async () => {
      try {
        const result = await onMiss(key)
        setTimeout(() => {
          this.cache.delete(key)
        }, this.ttl)
        return result
      } catch (e) {
        this.cache.delete(key)
        throw e
      }
    })()
    this.cache.set(key, promise)
    return promise
  }
}
